<script setup lang="ts">
const props = withDefaults(defineProps<{
  types?: string[],
}>(), {
  types: ['place', 'locality'],
})

const config = useRuntimeConfig()

const searchTerm = ref('')
const searchTermDebounced = refDebounced(computed(() => searchTerm.value.trim()), 200)
const { data: mapboxItems, status: mapboxStatus, execute } = await useFetch('https://api.mapbox.com/search/geocode/v6/forward', {
  params: {
    q: searchTermDebounced,
    language: 'fr-FR',
    country: 'fr,gf,pf,gp,mq,yt,re,bl,mf,pm,nc,wf',
    limit: 5,
    types: props.types.join(','),
    access_token: config.public.mapboxApiKey
  },
  transform: (data) => data.features.map(function (item) {

    let value = item.properties.full_address
    if (item.properties.feature_type === 'place' || item.properties.feature_type === 'locality') {
      const dpt =  item.properties.context.region?.region_code
      value = item.properties.name + (dpt ? ` (${dpt.substr(0, 2)})` : '')
    }

    return {
      country: item.properties.context.country.name,
      country_code: item.properties.context.country.country_code,
      value: value,
      coordinates: `${item.properties.coordinates.latitude},${item.properties.coordinates.longitude}`
    }
  }),
  server: false,
  lazy: true,
  immediate: false,
  watch: false,
})

watch(searchTermDebounced, (newValue) => {
  if (newValue.length >= 2) {
    execute()
  } else {
    mapboxItems.value = []
  }
})

const selectedLocation = defineModel()
</script>

<template>
  <UInputMenu v-model="selectedLocation" v-model:search-term="searchTerm"
              :items="mapboxItems || []"
              :loading="mapboxStatus === 'pending'"
              placeholder="Nantes, Paris, …"
              label-key="value"
              ignore-filter
              size="md"
              :open="searchTermDebounced.length >= 2 && (searchTermDebounced.length > 2 || mapboxStatus !== 'pending')"
              clear
  />
</template>